import {
  faInfoCircle,
  faSpinner,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React from "react";
import { createPortal } from "react-dom";

import Rows from "./Rows";
import NapTime from "../../assets/imgs/otto-scribbles-sleep.svg";
import { DeleteMultiModal } from "../common/multiselect/DeleteMultiModal";

export default function InboxWindow({
  isExportWindow = false,
  isAlreadyExported,
  description,
  refetch,
  data,
  fetchMore,
  notesLoading,
  activeTab = null,
}) {
  if (data?.inboxNotes?.totalNotes === 0) {
    return (
      <div className="rounded-xl h-[556px] shadow-md overflow-y-auto p-4 space-y-3 flex items-center justify-center">
        <div className="mx-auto">
          <div className="flex flex-col items-center justify-center space-y-5">
            <img
              className="flex self-center"
              width="300px"
              src={NapTime}
            />
            <h4 className="text-center text-base text-secondary">
              We&apos;re taking a paws...
            </h4>
            <h5 className="w-1/2 text-center text-sm text-placeholder">
              There&apos;s nothing to show here yet. Any notes or
              recordings you create will be found under the different
              tabs here depending on their status.
            </h5>
          </div>
        </div>
      </div>
    );
  }

  return (
    <>
      {document.readyState === "complete" &&
      document.getElementById("root-node")
        ? createPortal(
            <DeleteMultiModal
              notes={data?.inboxNotes?.notes}
              refetch={refetch}
            />,
            document.getElementById("root-node"),
          )
        : null}

      <div className="rounded-xl px-4">
        {description && !notesLoading ? (
          <h5
            className={`text-xs md:text-sm text-placeholder text-center mt-2 rounded-lg p-2 mb-2`}
          >
            <FontAwesomeIcon icon={faInfoCircle} /> {description}
          </h5>
        ) : null}

        {notesLoading ? (
          <div className="flex justify-center text-primary items-center h-64">
            <FontAwesomeIcon
              icon={faSpinner}
              className="text-4xl text-placeholder animate-spin"
            />
          </div>
        ) : (
          <Rows
            items={data?.inboxNotes?.notes ?? []}
            itemCount={data?.inboxNotes?.totalNotes ?? 0}
            isExportWindow={isExportWindow}
            isAlreadyExported={isAlreadyExported}
            refetch={refetch}
            fetchMore={fetchMore}
            activeTab={activeTab}
          />
        )}
      </div>
    </>
  );
}
